import { render, staticRenderFns } from "./ContrattiDiServizioDataTable.vue?vue&type=template&id=74cdcb0e&scoped=true"
import script from "./ContrattiDiServizioDataTable.vue?vue&type=script&lang=js"
export * from "./ContrattiDiServizioDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cdcb0e",
  null
  
)

export default component.exports